import { LojaPageContainer } from "../common";
import DashboardFinanceiroPage from "./dashboard";

/**
 * Dashboard financeiro da loja — visão geral (GET /loja/financeiro/dashboard).
 * Lançamentos detalhados: /loja/financeiro/lancamentos-vendas
 */
export default function LojaFinanceiro() {
  return (
    <LojaPageContainer
      title="Dashboard Financeiro"
      subtitle="Visão geral de caixa, vendas da loja e recebíveis."
    >
      <DashboardFinanceiroPage />
    </LojaPageContainer>
  );
}
